// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"team-members-icon-wrapper_iconsWrapper__BcpIg","icon":"team-members-icon-wrapper_icon__zedVI"};